const API_BASE_URL = process.env.REACT_APP_FIREBASE_API_URL;

// Use a function to get the URL from environment variable
const getApiUrl = () => API_BASE_URL;

class LoreService {
  async getLoreData() {
    try {
      const apiUrl = getApiUrl();
      if (!apiUrl) {
        throw new Error('API URL not configured');
      }

      const response = await fetch(`${apiUrl}/packet_tiers.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch lore data');
      }
      return await response.json();
    } catch (error) {
      console.error('Error fetching lore data:', error);
      return null;
    }
  }

  async getPlayerLoreProgress(discordId) {
    try {
      const apiUrl = getApiUrl();
      if (!apiUrl) {
        throw new Error('API URL not configured');
      }

      

      const response = await fetch(`${apiUrl}/players/${discordId}.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch player data');
      }
      const playerData = await response.json();
      
      // Initialize default structure if no lore data exists
      const loreProgress = playerData?.lore || {
        tier_1: [],
        tier_2: [],
        tier_3: [],
        tier_4: [],
        totalCompleted: 0
      };

      

      return loreProgress;
    } catch (error) {
      console.error('Error fetching player lore progress:', error);
      return null;
    }
  }

  // Generate a random 4-letter string
  generatePacketKey() {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    return Array.from({ length: 4 }, () => letters.charAt(Math.floor(Math.random() * letters.length))).join('');
  }

  async updateLoreProgress(discordId, loreId, completionData) {
    try {
      const apiUrl = getApiUrl();
      if (!apiUrl) {
        throw new Error('API URL not configured');
      }

      

      // Get current player data
      const response = await fetch(`${apiUrl}/players/${discordId}.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch player data');
      }
      const playerData = await response.json();
      
      // Initialize or update lore data with nested tier structure
      const currentLore = playerData?.lore || {
        tier_1: [],
        tier_2: [],
        tier_3: [],
        tier_4: [],
        totalCompleted: 0
      };
      
      
      // Extract tier and id from loreId (e.g., "tier_1_mindfabric")
      const [tier, ...rest] = loreId.split('_');
      const entryId = rest.join('_');
      const tierKey = `${tier}_${rest[0]}`; // e.g., "tier_1"
      
    

      // Ensure we're not duplicating entries
     

      // Check if the lore entry is already completed
      const isAlreadyCompleted = currentLore[tierKey]?.includes(entryId);

      if (!isAlreadyCompleted) {
        // Generate packet key only if lore is not already completed
        const packetKey = this.generatePacketKey();

        // Get existing packet keys for the user
        const existingKeysResponse = await fetch(`${apiUrl}/packet_keys/${discordId}.json`);
        const existingKeys = await existingKeysResponse.json();
        
        // Create array of keys, including existing ones if any
        const updatedKeys = Array.isArray(existingKeys) ? [...existingKeys, packetKey] : [packetKey];

        // Update packet_keys at Firebase root with the array of keys
        const packetKeyResponse = await fetch(`${apiUrl}/packet_keys/${discordId}.json`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedKeys)
        });

        if (!packetKeyResponse.ok) {
          throw new Error('Failed to update packet key');
        }
      }

      // Only update lore progress if entry hasn't been completed
      const updatedLore = {
        ...currentLore,
        [tierKey]: isAlreadyCompleted
          ? currentLore[tierKey]
          : [...(currentLore[tierKey] || []), entryId].sort(),
        totalCompleted: isAlreadyCompleted
          ? currentLore.totalCompleted
          : currentLore.totalCompleted + 1
      };

      

    

      // Update player data with new lore progress
      const updateResponse = await fetch(`${apiUrl}/players/${discordId}/lore.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedLore)
      });

      if (!updateResponse.ok) {
        throw new Error('Failed to update lore progress');
      }

      return true;
    } catch (error) {
      console.error('Error updating lore progress:', error);
      return false;
    }
  }

  async unlockTier(discordId, tierId) {
    try {
      const apiUrl = getApiUrl();
      if (!apiUrl) {
        throw new Error('API URL not configured');
      }

      // Get current player data
      const response = await fetch(`${apiUrl}/players/${discordId}.json`);
      if (!response.ok) {
        throw new Error('Failed to fetch player data');
      }
      const playerData = await response.json();
      
      // Initialize or get current lore data
      const currentLore = playerData?.lore || { completedLore: {}, unlockedTiers: ['tier_1'], totalCompleted: 0 };
      const unlockedTiers = new Set(currentLore.unlockedTiers || ['tier_1']);
      unlockedTiers.add(tierId);

      // Update unlockedTiers in player's lore data
      const updateResponse = await fetch(`${apiUrl}/players/${discordId}/lore/unlockedTiers.json`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(Array.from(unlockedTiers))
      });

      return updateResponse.ok;
    } catch (error) {
      console.error('Error unlocking tier:', error);
      return false;
    }
  }
}

export default new LoreService();